<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 4a4 4 0 014 4 1 1 0 002 0A6 6 0 006 8v7h-.75a.76.76 0 00-.75.75v5.5a.76.76 0 00.75.75h3.5a.76.76 0 00.75-.75v-.92h2.25a.75.75 0 00.75-.75v-2.16a.75.75 0 00-.75-.75h-1.21l1.31-1.32a.49.49 0 00-.7-.7L9.5 16.29v-.54a.76.76 0 00-.75-.75H8V8a4 4 0 014-4zM8.5 16v1.67h3v1.66h-3V21h-3v-5z"/><path d="M17.41 11.22a.52.52 0 00-.82 0A7.35 7.35 0 0015.25 14a1.75 1.75 0 003.5 0 7.35 7.35 0 00-1.34-2.78z"/></svg>